<app-header
  *ngIf="!(iframeService.iframeModeEnabled$ | async)"
  [user]="user"
  [menuOpened]="isSideNavOpened"
  [isHeaderTransparent]="isHeaderTransparent && !isSideNavOpened"
  (toggleSideNav)="toggleSideNav()"
>
  <button mat-button class="white-background" (click)="navigateToTopSalons()">
    {{ 'app-frame.buttons.top-salons' | translate }}
  </button>
  <lib-spacer [height]="10"></lib-spacer>
  <button
    mat-button
    class="white-background"
    (click)="navigateToPartnerLandingPage()"
  >
    {{ 'app-frame.buttons.be-partner' | translate }}
  </button>
  <lib-spacer [height]="10"></lib-spacer>
  <button
    mat-stroked-button
    class="white-background"
    color="primary"
    (click)="navigateToLogin()"
  >
    {{ 'app-frame.buttons.login' | translate }}
  </button>
  <lib-spacer [height]="10"></lib-spacer>
  <button mat-flat-button color="primary" (click)="navigateToRegister()">
    {{ 'app-frame.buttons.sign-up' | translate }}
  </button>
</app-header>

<mat-sidenav-container [hasBackdrop]="true">
  <mat-sidenav
    #sidenav
    fixedInViewport="false"
    [position]="'end'"
    [attr.role]="
      user || (breakpointService.isPhoneViewObservable | async)
        ? 'dialog'
        : 'navigation'
    "
    [mode]="'over'"
    [opened]="false"
    [disableClose]="false"
    (openedChange)="isSideNavOpened = $event"
  >
    <div class="centered-col">
      <div class="button-container">
        <lib-spacer></lib-spacer>

        <button
          class="full-width"
          mat-stroked-button
          (click)="navigateToTopSalons()"
        >
          {{ 'app-frame.buttons.top-salons' | translate }}
        </button>

        <lib-spacer [height]="10"></lib-spacer>

        <ng-container *ngIf="!user; else userButtonList">
          <button
            class="full-width"
            mat-flat-button
            color="primary"
            (click)="navigateToRegister()"
          >
            {{ 'app-frame.buttons.sign-up' | translate }}
          </button>

          <lib-spacer [height]="10"></lib-spacer>

          <button
            class="full-width"
            mat-stroked-button
            color="primary"
            (click)="navigateToLogin()"
          >
            {{ 'app-frame.buttons.login' | translate }}
          </button>

          <lib-spacer [height]="10"></lib-spacer>

          <button
            class="full-width"
            mat-button
            (click)="navigateToPartnerLandingPage()"
          >
            {{ 'app-frame.buttons.be-partner' | translate }}
          </button>
        </ng-container>
      </div>

      <div class="button-container">
        <ng-container *ngIf="!!user">
          <button
            class="full-width"
            mat-stroked-button
            color="primary"
            (click)="navigateToPartnerLandingPage()"
          >
            {{ 'app-frame.buttons.be-partner' | translate }}
          </button>

          <lib-spacer [height]="10"></lib-spacer>
        </ng-container>

        <button class="full-width" mat-button (click)="openLanguageDialog()">
          <img
            class="flag-icon"
            alt="{{ selectedLanguage?.countryCode }}"
            src="/assets/svg-country-flags/{{
              selectedLanguage?.countryCode?.toLowerCase()
            }}.svg"
          />
          <span>{{
            'pipes.language.' + selectedLanguage?.languageCode | translate
          }}</span>
        </button>

        <lib-spacer></lib-spacer>
      </div>
    </div>
  </mat-sidenav>

  <mat-sidenav-content #sidenavContent>
    <div class="page-content">
      <div *ngIf="showAgbHint && !isHeaderTransparent" class="hint-toolbar">
        <div class="clickable" (click)="openAgbReadonlyDialog()">
          <span class="highlight-link">{{
            'app-frame.text.agb-short' | translate
          }}</span>
          <span class="side-margin-xsmall">{{
            'app-frame.text.agb-updated-valid-since'
              | translate
                : { date: agb.validSince | dateParser | dateFormatter }
          }}</span>
          <span>({{ 'app-frame.text.click-to-read' | translate }})</span>
        </div>

        <button mat-icon-button (click)="hideAgbHint()">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <ng-content></ng-content>
    </div>

    <app-footer
      *ngIf="!(iframeService.iframeModeEnabled$ | async)"
    ></app-footer>
  </mat-sidenav-content>
</mat-sidenav-container>

<ng-template #userButtonList>
  <button
    class="full-width"
    [matBadgeOverlap]="true"
    [matBadgeHidden]="user?.emailConfirmed && user?.phoneNrConfirmed"
    matBadge="!"
    matBadgeColor="warn"
    mat-stroked-button
    (click)="navigateToUserProfile()"
  >
    {{ 'app-frame.buttons.profile' | translate }}
  </button>

  <lib-spacer [height]="10"></lib-spacer>

  <button
    class="full-width"
    mat-stroked-button
    (click)="navigateToSalonVisited()"
  >
    {{ 'app-frame.buttons.my-salons' | translate }}
  </button>

  <lib-spacer [height]="10"></lib-spacer>

  <button
    class="full-width"
    mat-stroked-button
    (click)="navigateToAppointmentHistory()"
  >
    {{ 'app-frame.buttons.my-appointments' | translate }}
  </button>

  <lib-spacer [height]="10"></lib-spacer>

  <button class="full-width" mat-button color="warn" (click)="logout()">
    {{ 'app-frame.buttons.logout' | translate }}
  </button>
</ng-template>
